import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ExistingClient from "@/components/ui/ExistingClient.vue";
import Kyc from "@/components/widgets/Kyc.vue";
import OnlineAccess from "@/components/widgets/OnlineAccess.vue";
import FirstLogin from "@/components/ui/FirstTimeLogin.vue";
import Success from "@/components/ui/Success.vue";
Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes:[
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/existing",
      name:"Existing",
      component:ExistingClient
    },
    {
      path:"/kyc/:tokenvalue",
      name:"kyc",
      component: Kyc
    },
    {
      path:"/onlineaccess",
      name:"onlineaccess",
      component: OnlineAccess
    },
    {
      path: "/success",
      name:"Success",
      component:Success
    },
    {
      path:"/firstlogin/:tokenvalue",
      name:"FirstLogin",
      component: FirstLogin
    },
    
    // // otherwise redirect to home
    // { path: "*", redirect: "/" }
  ],
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    // return desired position
    return { x: 0, y: 0 };
  },
  mode: "history"
});


export default router;
